module.exports = __webpack_public_path__ + "img/user.d89374fa.svg";